import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import { CurrencyFormat } from '@lt/components';
import type { CurrencyType } from '@lt/components/utils/currency';
import { pluralize } from '@lt/components/utils/userflow';
import BubbleFilter from 'src/components/Bubbles/BubbleFilter';
import styles from './filterLabel.module.css';

export interface IFilterLable {
  className?: string;
  price?: string | number;
  currencyCode?: CurrencyType;
  name: string;
  description?: string;
  count?: number;
  disabled?: boolean;
  selected?: boolean;
  isMobile?: boolean;
  emptyMessage?: string;
}

const FilterLabel: React.FC<IFilterLable> = ({
  count = 0,
  price,
  currencyCode,
  name,
  emptyMessage = 'нет отелей',
  description,
  isMobile = false,
  selected = false,
  disabled = false,
  className,
}) => {
  const hasOffersCount = count > 0;
  return (
    <div
      className={classnames(className, styles.filterLabel, {
        [styles.filterLabelSelected]: selected,
        [styles.filterLabelMobile]: isMobile,
        [styles.filterLabelDisabled]: disabled,
      })}
    >
      <div
        className={classnames(styles.itemNameContainer, {
          [styles.itemNameContainerDesktop]: !isMobile,
        })}
      >
        <span>{name}</span>
        {description && !isMobile ? (
          <BubbleFilter text={description} placement="right" />
        ) : null}
      </div>
      <div className={styles.itemInfo}>
        {!disabled && hasOffersCount && (
          <>
            <span>
              {count} {pluralize(count, ['отель', 'отеля', 'отелей'])}
            </span>
            <CurrencyFormat
              value={price}
              currencyCode={currencyCode}
              prefix=" от "
            />
          </>
        )}
        {disabled ? <span>{emptyMessage}</span> : null}
      </div>
    </div>
  );
};

FilterLabel.propTypes = {
  className: PropTypes.string,
};

FilterLabel.defaultProps = {
  className: '',
};

export default React.memo(FilterLabel);
